import React from "react";
import { ProducerAccountPreviewRevenueTransactionTemplate } from "themes/common/components/producer";

function ProducerAccountPreviewRevenueTransaction(props) {
    return <ProducerAccountPreviewRevenueTransactionTemplate {...props} />;
}

export default ProducerAccountPreviewRevenueTransaction;
